import { render, staticRenderFns } from "./prescription.vue?vue&type=template&id=3833aace&scoped=true"
import script from "./prescription.vue?vue&type=script&lang=js"
export * from "./prescription.vue?vue&type=script&lang=js"
import style0 from "./prescription.vue?vue&type=style&index=0&id=3833aace&prod&lang=scss&scoped=true"
import style1 from "./prescription.vue?vue&type=style&index=1&id=3833aace&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3833aace",
  null
  
)

export default component.exports